<template>
  <div class="home">
    <Header/>
    <Markets/>
    <Inovations/>
    <BusinessGroup/>
    <SharedNews/>
  </div>
</template>

<script>
import Header from "./Header";
import Markets from "./Markets";
import Inovations from "./Inovations";
import BusinessGroup from "./BusinessGroup";
import SharedNews from "../shared/SharedNews";
export default {
  components: {
    Header,
    Markets,
    Inovations,
    BusinessGroup,
    SharedNews
  }
};
</script>

<style>
</style>
